var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import cs from './weblate/cs.json';
import en from './weblate/en.json';
import es from './weblate/es.json';
import fr from './weblate/fr.json';
import pl from './weblate/pl.json';
import pt from './weblate/pt_BR.json';
import ru from './weblate/ru.json';
import sk from './weblate/sk.json';
import tr from './weblate/tr.json';
import uk from './weblate/uk.json';
import zhs from './weblate/zh_Hans.json';
var deepmerge = require('deepmerge');
var Localization = /** @class */ (function () {
    function Localization() {
    }
    Localization.getTranslations = function (language) {
        if (!language) {
            return this.currentTranslations;
        }
        var newLanguage = language.split('-')[0];
        if (newLanguage !== this.currentLanguage) {
            this.currentLanguage = newLanguage;
            this.setTranslations();
        }
        return this.currentTranslations;
    };
    Localization.setTranslations = function () {
        switch (this.currentLanguage) {
            case 'cs':
                this.currentTranslations = this.merge({ current: cs, fallback: en });
                break;
            case 'es':
                this.currentTranslations = this.merge({ current: es, fallback: en });
                break;
            case 'fr':
                this.currentTranslations = this.merge({ current: fr, fallback: en });
                break;
            case 'pl':
                this.currentTranslations = this.merge({ current: pl, fallback: en });
                break;
            case 'pt':
                this.currentTranslations = this.merge({ current: pt, fallback: en });
                break;
            case 'ru':
                this.currentTranslations = this.merge({ current: ru, fallback: en });
                break;
            case 'sk':
                this.currentTranslations = this.merge({ current: sk, fallback: en });
                break;
            case 'tr':
                this.currentTranslations = this.merge({ current: tr, fallback: en });
                break;
            case 'uk':
                this.currentTranslations = this.merge({ current: uk, fallback: en });
                break;
            case 'zh':
                this.currentTranslations = this.merge({ current: zhs, fallback: en });
                break;
            default:
                this.currentTranslations = en;
                break;
        }
    };
    Localization.merge = function (translations) {
        return deepmerge(translations.fallback, translations.current, {
            customMerge: function () { return function (fallback, current) {
                return __assign(__assign({}, fallback), Object.fromEntries(Object.entries(current).filter(function (_a) {
                    var value = _a[1];
                    return !!value;
                })));
            }; },
        });
    };
    Localization.currentTranslations = en;
    Localization.currentLanguage = 'en';
    return Localization;
}());
export { Localization };
